import { jsxs as m, jsx as a } from "react/jsx-runtime";
import { forwardRef as S, useState as T, useRef as $, useImperativeHandle as j, useEffect as l } from "react";
import { IS_IOS as I } from "../utils.js";
import e from "./loader.module.css.js";
import N from "clsx/lite";
const H = S(function({
  children: o,
  className: f,
  radius: p = "md",
  size: r = "md",
  style: y,
  timedContent: c,
  variant: n = "spinner",
  ...x
}, g) {
  const [b, i] = T(o), s = $(null), h = e[`size-${r}`] ? void 0 : Number(r) || r;
  return j(g, () => s.current), l(() => {
    var t;
    (t = s.current) == null || t.style.setProperty("--delay", R());
  }, []), l(() => {
    i(o), Object.entries(c || {}).forEach(
      ([t, v]) => setTimeout(() => i(v), Number(t))
    );
  }, [c, o]), /* @__PURE__ */ m(
    "span",
    {
      className: N(
        e.loader,
        e[`radius-${p}`],
        e[`size-${r}`],
        e[n],
        f
      ),
      style: { height: h, ...y },
      ref: s,
      role: I ? void 0 : "progressbar",
      ...x,
      children: [
        n === "spinner" && /* @__PURE__ */ m("svg", { viewBox: "25 25 50 50", "aria-hidden": "true", children: [
          /* @__PURE__ */ a("circle", { cx: "50", cy: "50", r: "20" }),
          /* @__PURE__ */ a("circle", { cx: "50", cy: "50", r: "20" })
        ] }),
        b
      ]
    }
  );
});
let u = 0, d;
const R = () => (clearTimeout(d), d = setTimeout(() => u = 0, 1e3), `${u++ * 100}ms`);
export {
  H as Loader
};
//# sourceMappingURL=loader.js.map
